import CartHelper from './CartHelper';

export default class CalculateTotalSum {
    constructor() {
        this.totalElement = document.querySelector('#totalElement');

        this.eventDeliveryDropdowns = document.querySelectorAll('.delivery-dropdown-event');
        this.seasonDeliveryDropdowns = document.querySelectorAll('.delivery-dropdown-season');
        this.productDeliveryDropdowns = document.querySelectorAll('.delivery-dropdown-product');

        this.orderEvents = document.querySelector('#orderEvents');
        this.orderSeasons = document.querySelector('#orderSeasons');
        this.productDeliveryTypes = document.querySelector('#productDeliveryTypes');

        this._eventDeliveryTypeChanged = this._eventDeliveryTypeChanged.bind(this);
        this._seasonDeliveryTypeChanged = this._seasonDeliveryTypeChanged.bind(this);
        this._productDeliveryTypeChanged = this._productDeliveryTypeChanged.bind(this);

        if (this.eventDeliveryDropdowns) {
            Array.prototype.slice.call(this.eventDeliveryDropdowns).forEach(
                element => element.addEventListener('change', this._eventDeliveryTypeChanged));
        }

        if (this.seasonDeliveryDropdowns) {
            Array.prototype.slice.call(this.seasonDeliveryDropdowns).forEach(
                element => element.addEventListener('change', this._seasonDeliveryTypeChanged));
        }

        if (this.productDeliveryDropdowns) {
            Array.prototype.slice.call(this.productDeliveryDropdowns).forEach(
                element => element.addEventListener('change', this._productDeliveryTypeChanged));
        }

        this.init = this.init.bind(this);

        this.init();
    }

    init() {
        CartHelper.setEventDeliveryDropdownsFromSession();
        CartHelper.setSeasonDeliveryDropdownsFromSession();
        CartHelper.setProductDeliveryDropdownFromSession();

        if (this.totalElement) {
            updateOrderPrices(
                JSON.parse(this.orderEvents.value),
                JSON.parse(this.orderSeasons.value),
                JSON.parse(this.productDeliveryTypes.value));
            showFlashSeatsHints();
        }
    }

    _eventDeliveryTypeChanged(e) {
        CartHelper.setSelectedDeliveryTypeFromEventDropdownToSession();
        let eventIdKey = e.target.id.replace('SelectedDeliveryTypeId', 'Id');
        let eventId = document.getElementById(eventIdKey).value;
        updateEventDeliveryTypeCost(
            JSON.parse(this.orderEvents.value),
            JSON.parse(this.orderSeasons.value),
            JSON.parse(this.productDeliveryTypes.value),
            eventId,
            e.target.value);
    }

    _seasonDeliveryTypeChanged(e) {
        CartHelper.setSelectedDeliveryTypeFromSeasonDropdownToSession();
        let seasonIdKey = e.target.id.replace('SelectedDeliveryTypeId', 'Id');
        let seasonId = document.getElementById(seasonIdKey).value;
        updateSeasonDeliveryTypeCost(
            JSON.parse(this.orderEvents.value),
            JSON.parse(this.orderSeasons.value),
            JSON.parse(this.productDeliveryTypes.value),
            seasonId,
            e.target.value);
    }

    _productDeliveryTypeChanged() {
        CartHelper.setSelectedDeliveryTypeFromProductDropdownToSession();
        updateProductDeliveryTypeCost(
            JSON.parse(this.orderEvents.value),
            JSON.parse(this.orderSeasons.value),
            JSON.parse(this.productDeliveryTypes.value));
    }
}

function updateOrderPrices(events, seasons, productDeliveryTypes) {
    updatePrice("selectedDeliveryTypeIdElement", "deliveryTypeElement");
    updateDeliveryTotalSum(events, seasons, productDeliveryTypes);
    updatePrice("totalCostElement", "totalElement");
    updatePriceWithoutPayments("totalCostElement", "totalElementWithoutPayments");

    if (CartHelper.isAxsIdEnabled() === true) {
        refreshKlarnaIFrame();
    }
}

function updatePrice(countedElementsClassName, resultElementId) {
    let sum = countSum(countedElementsClassName);
    let resultElement = document.getElementById(resultElementId);

    resultElement.innerText = sum;
}

function updatePriceWithoutPayments(countedElementsClassName, resultElementId) {
    let payments = document.querySelector('#payments');

    if (payments) {
        let sum = countSum(countedElementsClassName);

        let paymentKeys = Object.keys(JSON.parse(payments.value));
        let paymentSum = paymentKeys.reduce((a, b) => Number(a) + Number(b), 0);

        let resultElement = document.getElementById(resultElementId);

        resultElement.innerText = sum - paymentSum;
    }
}

function updateEventDeliveryTypeCost(orderEvents, orderSeasons, productDeliveryTypes, eventId, selectedDeliveryTypeId) {
    CartHelper.setCostForEventDeliveryDropdown(eventId, selectedDeliveryTypeId);
    updateOrderPrices(orderEvents, orderSeasons, productDeliveryTypes);
    showFlashSeatsHints();
}

function updateSeasonDeliveryTypeCost(orderEvents, orderSeasons, productDeliveryTypes, seasonId, selectedDeliveryTypeId) {
    CartHelper.setCostForSeasonDeliveryDropdown(seasonId, selectedDeliveryTypeId);
    updateOrderPrices(orderEvents, orderSeasons, productDeliveryTypes);
    showFlashSeatsHints();
}

function updateProductDeliveryTypeCost(orderEvents, orderSeasons, productDeliveryTypes) {
    CartHelper.setCostForProductDeliveryDropdown();
    updateOrderPrices(orderEvents, orderSeasons, productDeliveryTypes);
}

function showFlashSeatsHints() {
    let flashSeatModElement = document.querySelector('#flashSeatModId');
    let deliveryDropdownElements = document.querySelectorAll(".delivery-dropdown-event, .delivery-dropdown-season");
    let selectedDeliveryTypeId;
    let flashSeatModId;

    Array.prototype.slice.call(deliveryDropdownElements).forEach(function (deliveryDropdownElement) {
        if (deliveryDropdownElement) {
            selectedDeliveryTypeId = deliveryDropdownElement.value;
        }

        if (flashSeatModElement) {
            flashSeatModId = flashSeatModElement.value;
        }

        var axsMobileIdInfoTextElement = $('#axs-mobile-id-info-text');
        if (parseInt(selectedDeliveryTypeId) === parseInt(flashSeatModId)) {
            axsMobileIdInfoTextElement.show();
        } else {
            axsMobileIdInfoTextElement.hide();
        }
    });
}

function updateDeliveryTotalSum(orderEvents, orderSeasons, productDeliveryTypes) {
    let uniqueSelectedDeliveryTypeNames = getUniqueSelectedDeliveryTypeNames();
    let uniqueDeliveryTypes = getUniqueDeliveryTypesForOrder(orderEvents, orderSeasons, productDeliveryTypes);
    let deliveryTypeElement = document.getElementById("deliveryTypeElement");
    let totalSum = countDeliveryTotalSum(uniqueSelectedDeliveryTypeNames, uniqueDeliveryTypes);

    deliveryTypeElement.innerText = totalSum;
}

function getUniqueSelectedDeliveryTypeNames() {
    let eventDeliveryDropDownElements = document.getElementsByClassName("delivery-dropdown-event");
    let seasonDeliveryDropDownElements = document.getElementsByClassName("delivery-dropdown-season");
    let productDeliveryDropDownElements = document.getElementsByClassName("delivery-dropdown-product");
    let selectedDeliveryTypeNames = [];

    let eventDeliveryDropDownElementsArray = Array.from(eventDeliveryDropDownElements);
    Array.prototype.slice.call(eventDeliveryDropDownElementsArray).forEach(function (element) {
        selectedDeliveryTypeNames.push(element.options[element.selectedIndex].text);
    });

    let seasonDeliveryDropDownElementsArray = Array.from(seasonDeliveryDropDownElements);
    Array.prototype.slice.call(seasonDeliveryDropDownElementsArray).forEach(function (element) {
        selectedDeliveryTypeNames.push(element.options[element.selectedIndex].text);
    });

    let productDeliveryDropDownElementsArray = Array.from(productDeliveryDropDownElements);
    Array.prototype.slice.call(productDeliveryDropDownElementsArray).forEach(function (element) {
        selectedDeliveryTypeNames.push(element.options[element.selectedIndex].text);
    });

    let uniqueSelectedDeliveryTypeNames = uniqueElements(selectedDeliveryTypeNames);

    return uniqueSelectedDeliveryTypeNames;
}

function getUniqueDeliveryTypesForOrder(orderEvents, orderSeasons, productDeliveryTypes) {
    let allDeliveryTypes = [];

    Array.prototype.slice.call(orderEvents)
        .forEach(event => event.deliveryTypes.forEach(deliveryType => allDeliveryTypes.push(deliveryType)));

    Array.prototype.slice.call(orderSeasons)
        .forEach(season => season.deliveryTypes.forEach(deliveryType => allDeliveryTypes.push(deliveryType)));

    Array.prototype.slice.call(productDeliveryTypes)
        .forEach(deliveryType => allDeliveryTypes.push(deliveryType));

    let allUniqueDeliveryTypes = uniqueDeliveryTypes(allDeliveryTypes);

    return allUniqueDeliveryTypes;
}

function countDeliveryTotalSum(deliveryTypeNames, deliveryTypes) {
    let totalSum = 0;

    Array.prototype.slice.call(deliveryTypeNames).forEach(function (deliveryTypeName) {
        let deliveryType = deliveryTypes.find(deliveryType => deliveryType.sfriendlyname === deliveryTypeName);
        if (deliveryType && deliveryType.cost) {
            totalSum += parseInt(deliveryType.cost);
        }
    });

    return totalSum;
}

function countSum(countedElementsClassName) {
    let elements = Array.from(document.getElementsByClassName(countedElementsClassName));
    let sum = elements.reduce((acc, element) => acc + parseInt(element.innerText), 0);

    return sum;
}

function uniqueElements(arr) {
    let uniqueElements = [];

    Array.prototype.slice.call(arr).forEach(function (item) {
        if (!~uniqueElements.indexOf(item)) {
            uniqueElements.push(item);
        }
    });

    return uniqueElements;
}

function uniqueDeliveryTypes(arr) {
    let uniqueElements = [];

    Array.prototype.slice.call(arr).forEach(function (item) {
        if (uniqueElements.find(element => element.id === item.id) === undefined) {
            uniqueElements.push(item);
        }
    });

    return uniqueElements;
}

function refreshKlarnaIFrame() {
    const cartIndexViewModel = CartHelper.populateCartIndexViewModel();

    let klarnaDiv = document.getElementById("klarna");
    if (klarnaDiv) {
        klarnaDiv.style.display = "none";
    }

    let spinner = document.getElementById("cube-loader");
    if (spinner) {
        spinner.style.display = "block";
    }

    if (klarnaDiv) {
        $.ajax({
            url: "/Cart/GetRefreshedKlarnaCheckoutHtmlSnippet",
            dataType: "json",
            type: "POST",
            data: { model: cartIndexViewModel },
            success: function (response) {
                klarnaDiv.style.display = "block";
                spinner.style.display = "none";
                $('#klarna').html(response.htmlSnippet);
            }
        });
    }
}